import { Controller } from "@hotwired/stimulus"

// PΔ.301.9 — «Скачать PDF»: PDF отдаётся только в указанный канал.
// Telegram — по deep-link (кнопка-ссылка). WhatsApp/телефон и email — через
// API контактов с флагом want_pdf; язык берём с текущей страницы.
export default class extends Controller {
  static targets = ["waForm", "phone", "email", "button", "waButton", "ok", "error"]
  static values = { endpoint: String }

  toggleWa() {
    const f = this.waFormTarget
    f.style.display = f.style.display === "none" ? "flex" : "none"
  }

  async email(event) {
    event.preventDefault()
    const value = this.emailTarget.value.trim()
    if (!value) return
    await this.send(this.buttonTarget, { kind: "email", value })
    this.emailTarget.value = ""
  }

  async whatsapp(event) {
    event.preventDefault()
    const value = this.phoneTarget.value.trim()
    if (!value) return
    await this.send(this.waButtonTarget, { kind: "whatsapp", value })
    this.phoneTarget.value = ""
  }

  async send(button, payload) {
    button.disabled = true
    this.okTarget.style.display = "none"
    this.errorTarget.style.display = "none"
    const ok = await this.post(payload)
    button.disabled = false
    ;(ok ? this.okTarget : this.errorTarget).style.display = "block"
  }

  async post(body) {
    try {
      const resp = await fetch(this.endpointValue, {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]")?.content || ""
        },
        body: JSON.stringify({ locale: document.documentElement.lang, want_pdf: true, ...body })
      })
      return resp.ok
    } catch (_) {
      return false
    }
  }
}
